import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'form-registry',
  templateUrl: './form-registry.component.html',
  styleUrls: ['./form-registry.component.scss']
})
export class FormRegistryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
